// extracted by mini-css-extract-plugin
module.exports = {"section":"Sect3_Comp1_section__3kg_y","content":"Sect3_Comp1_content__4MItn","persona":"Sect3_Comp1_persona__347DE"};